import React, { useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import InputTextarea from '../UI/Control/InputTextarea';
import classes from './../TrialstatNoto.module.css';
import { useSelector } from 'react-redux'
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import AdjCodeModal from './AdjCodeHistoyModal';

const AdjudicationPrograming = (props) => {
    const EDCUserID = useSelector(state => state.auth.gValue01);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        fetchAdjConfiguration();
        fetchAdjNotes();
        setShow(true);
    };
    const [rowData, setRows] = useState([]);
    const fetchAdjNotes = () => {
        fetch('api/AdjudicationSettings/GetAdjNotes?studyReadSettingsID=' + props.studyReadSettingsID)
            .then(response => response.json())
            .then(data => {
                setRows(data);
            });
    };

    const fetchAdjConfiguration = () => {
        fetch('api/AdjudicationSettings/GetAdjConfiguration?studyReadSettingsID=' + props.studyReadSettingsID)
            .then(response => response.json())
            .then(data => {
                document.getElementById('txtAdjDetermination').value = data.AdjDetermination;
            });
    };

    const SaveAdjConfig = (event) => {
        let objAdjDetermination = document.getElementById('txtAdjDetermination');
        let objAdjNotes = document.getElementById('txtAdjNotes');

        if (objAdjDetermination.value.trim() == '') {
            alert('Adjudication determination should not be empty.');
            objAdjDetermination.focus();
            return false;
        }

        if (objAdjNotes.value.trim() == '') {
            alert('Adjudication notes should not be empty.');
            objAdjNotes.focus();
            return false;
        }

        let objAdjConfig =
        {
            StudyReadSettingsID: props.studyReadSettingsID,
            AdjDetermination: objAdjDetermination.value,
            AdjOutDetermination: '',
            UpdatedBy: EDCUserID,
            AdjNotes: objAdjNotes.value
        }

        fetch('api/AdjudicationSettings/UpdateAdjConfiguration', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(objAdjConfig)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Adjudication configuration not saved, Something went wrong.');
                return false;
            }
            if (res > 0 || res == "" ) {
                props.fetchAdjSettingDetail();
                setShow(false);
            }
        })
        return true;
    };

    return (
        <>
            <Button className={"btn btn-md " + (props.isAdjConfigSubmit === true ? "btn-success" : "btn-warning")} variant="primary" onClick={handleShow}> {props.text} </Button>
            <Modal centered
                show={show}
                onHide={handleClose}
                dialogClassName={classes.TSModalDailog_TwentyOne} backdrop="static">

                <Modal.Header style={{ display: "block", textAlign: "left" }}>
                    <Modal.Title style={{ textAlign: "left" }}>
                        <label>{props.studyName}</label>
                        <label style={{ float: "right", fontSize:"15px" }}> <b style={{ marginLeft: "10px", marginTop: "5px" }}>{props.header}</b> </label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={classes.TSModalDailog_TwentyOne_Body}>
                    <div className="row">
                        <div className="col-sm-7">
                            <p><b>Adjudication Determination</b><MandatoryLabel></MandatoryLabel></p>
                            <div className="App">
                                <InputTextarea id="txtAdjDetermination" rows="25" cols="75"></InputTextarea>
                            </div>
                        </div>
                        <div className="col-sm-5">
                            <p><b>Adjudication Notes</b><MandatoryLabel></MandatoryLabel></p>
                            <InputTextarea id="txtAdjNotes" rows="4" cols="75" maxlength="200"></InputTextarea>
                            <div style={{ textAlign: "right", marginTop: "10px" }}>
                                {!props.disabled && <Button className="btn btn-md btn-success" variant="primary" style={{ marginLeft: "10px" }} onClick={SaveAdjConfig}> Save </Button>}
                                <Button className="btn btn-md btn-danger" variant="secondary" onClick={handleClose} style={{ marginLeft: "10px" }}> Close </Button>
                            </div>
                            <div style={{ "display": rowData.length > 0 ? " " : "none" }}>
                                <p> <strong>Notes History</strong> </p>
                                    <table style={{ tableLayout: "fixed", display: "block", width: "100%" }} >
                                        <thead style={{ width: "100%", tableLayout:"fixed" }}>
                                            <tr style={{ display: "table", width: "100%", tableLayout: "fixed" }}>
                                                <th className={classes.tbHeaderCaptionDark} style={{ textAlign: "center", width: "30%", tableLayout: "fixed" }} >Adjudication Notes</th>
                                                <th className={classes.tbHeaderCaptionDark} style={{ textAlign: "center", width: "25%", tableLayout: "fixed" }} >User</th>
                                                <th className={classes.tbHeaderCaptionDark} style={{ textAlign: "center", width: "25%", tableLayout: "fixed" }} >Date</th>
                                                <th className={classes.tbHeaderCaptionDark} style={{ textAlign: "center", width: "20%", tableLayout: "fixed" }} >Action</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{display:"block", maxHeight: "41vh", height: "41vh", overflowY: "scroll", overflowX: "hidden", width:"100%" }}>
                                            {rowData.map((item) => {
                                                return (
                                                    <tr style={{ display: "table", width: "100%", tableLayout: "fixed" }}>
                                                        <td className={classes.textWrap} style={{ width: "30%", wordWrap: "break-word", tableLayout:"fixed" }}>{item.AdjNotes}</td>
                                                        <td style={{ width: "25%", tableLayout: "fixed" }}>{item.UpdatedBy}</td>
                                                        <td style={{ width: "25%", tableLayout: "fixed" }}>{item.HistoryDate}</td>
                                                        <td style={{ width: "20%", tableLayout: "fixed" }}>
                                                            {
                                                                <AdjCodeModal btn="true" text="Adj Code" AdjCode={item.AdjDetermination} AdjTitle="Adjudication Code from history" ></AdjCodeModal>
                                                            }
                                                        </td>
                                                    </tr>);
                                            })
                                            }
                                        </tbody>
                                    </table>
                            </div>
                        </div>
                    </div>
                    

                    
                </Modal.Body>
            </Modal>
        </>
    );
}
export default AdjudicationPrograming;